export const revertPreviewTheme = {
  diff: {
    divider: 'palette.tertiary.30',
  },
  entry: {
    arrow: 'palette.tertiary.60',
    base: {
      borderColor: 'palette.tertiary.30',
      borderRadius: '8px',
      borderWidth: '1px',
    },
  },
  meta: {
    label: 'palette.tertiary.60',
  },
};
